import { Link, styled } from '@mui/material';
import { listItemIconClasses } from '@mui/material/ListItemIcon';

const StyledMainMenuNestedLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  textDecoration: 'none',
  width: '100%',
  '&:last-child': {
    marginBottom: '10px'
  },
  // Activo NEUTRO (antes azul primary.light, fuera de marca): el relleno gris lo
  // pone el botón vía `selected`; aquí solo el ícono acompaña.
  '&.active': {
    [`& .${listItemIconClasses.root}`]: {
      color: theme.palette.selected.fg
    }
  }
}));

export default StyledMainMenuNestedLink;
